import { queryOptions } from '@tanstack/react-query'
import customReportQueryKeys, { SectionQueryParams } from '../customReportQueryKeys'
import { fetchCustomReportSectionQuery } from '../../service/customReportSectionService'

export const customReportSectionOptions = (
  companyId: string,
  reportId: number,
  sectionId: number,
  params: SectionQueryParams,
  enabled: boolean
) => {
  return queryOptions({
    queryKey: customReportQueryKeys.section(companyId, reportId, sectionId, params),
    queryFn: fetchCustomReportSectionQuery,
    enabled: enabled && !!companyId && !!reportId && !!sectionId,
    staleTime: Infinity
  })
}
